module.exports = __webpack_public_path__ + "static/media/not_found.d0142ac8.svg";